var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-button',{attrs:{"label":"修正箇所確認用ファイルをダウンロード","icon":"fas fa-download","running":_vm.isTemplateDownloading},on:{"click":_vm.download}})}
var staticRenderFns = []

export { render, staticRenderFns }